import { css } from 'styled-components';

// Elevation - z4
export const cardShadow = css`
  box-shadow: 0px 1px 10px 0px rgba(19, 36, 69, 0.05),
    0px 4px 5px 0px rgba(19, 36, 69, 0.05),
    0px 2px 4px -1px rgba(19, 36, 69, 0.1);
`;
